import { Outlet, Route, Routes, useParams } from "react-router";
import { MainSectionTitle } from "../../common";
import EditSizeGuide from "../components/crud/EditSizeGuide";
import NewSizeGuide from "../components/crud/NewSizeGuide";
import DashboardSizeGuides from "../components/dashboard/DashboardSizeGuides";
import { FormattedMessage } from "react-intl";

//interface RowData {
//  StorePlan: "Free" | "Pro" | "Enterprise";
//  Status: "Active" | "Inactive";
//}

//const elements: RowData[] = [
//  { StorePlan: "Free", Status: "Active" },
//  { StorePlan: "Pro", Status: "Inactive" },
//];

//const storePlan: "Free" | "Pro" | "Enterprise" = "Free";

// SizeGuidesAvailable

const MainSizeGuides = (props: any) => {
  const params = useParams();

  const mainSectionContent = () => {
    const title =
      params["*"] === "" ? (
        <FormattedMessage id="ready-size-sizes-guides" />
      ) : params["*"] === "add" ? (
        <FormattedMessage id="ready-size-new-size-guide" />
      ) : (
        <FormattedMessage id="main-edit-sizeguides-title" />
      );

    const subtitle =
      params["*"] === "" ? (
        <FormattedMessage id="main-sizeguides-subtitle" />
      ) : params["*"] === "add" ? (
        <FormattedMessage id="main-new-sizeguides-subtitle" />
      ) : (
        <FormattedMessage id="main-edit-sizeguides-subtitle" />
      );

    return {
      title: title,
      subtitle: subtitle,
    };
  };

  return (
    <>
      <MainSectionTitle {...mainSectionContent()} />

      <div className="mt-4">
        <Outlet />
      </div>

      <Routes>
        <Route
          path="/"
          element={
            <DashboardSizeGuides />
          }
        />
        <Route
          path="/add"
          element={<NewSizeGuide selectedLanguage={props.selectedLanguage} />}
        />
        <Route
          path="/edit/:id"
          element={<EditSizeGuide selectedLanguage={props.selectedLanguage} />}
        />
      </Routes>
    </>
  );
};

export default MainSizeGuides;

// const MainSizeGuides = (props: any) => {
//   const params = useParams();

//   const mainSectionContent = () => {
//     const title =
//       params["*"] === "" ? (
//         <FormattedMessage id="ready-size-sizes-guides" />
//       ) : params["*"] === "add" ? (
//         <FormattedMessage id="ready-size-new-size-guide" />
//       ) : (
//         <FormattedMessage id="main-edit-sizeguides-title" />
//       );

//     const subtitle =
//       params["*"] === "" ? (
//         <FormattedMessage id="main-sizeguides-subtitle" />
//       ) : params["*"] === "add" ? (
//         <FormattedMessage id="main-new-sizeguides-subtitle" />
//       ) : (
//         <FormattedMessage id="main-edit-sizeguides-subtitle" />
//       );

//     return {
//       title: title,
//       subtitle: subtitle,
//     };
//   };

//   // const mainSectionContent = () => {
//   //   const title =
//   //     params["*"] === ""
//   //       ? "Guías de talles"
//   //       : params["*"] === "add"
//   //       ? "Nueva Guía de Talles"
//   //       : "Editar Guía de Talles";

//   //   const subtitle =
//   //     params["*"] === ""
//   //       ? "En esta sección vas a poder generar y administrar tus guías de talles. Las guías son escenciales para el funcionamiento de FitPrenda, la información de las guías la utliza la aplicación para recomendar los talles a los clientes."
//   //       : params["*"] === "add"
//   //       ? "Completa los datos para generar tu guía y luego podrás aplicarla a tus productos"
//   //       : "Completa los datos para generar tu guía y luego podrás aplicarla a tus productos";

//   //   return {
//   //     title: title,
//   //     subtitle: subtitle,
//   //   };
//   // };

//   return (
//     <>
//       <MainSectionTitle {...mainSectionContent()} />

//       <div className="mt-4">
//         <Outlet />
//       </div>

//       <Routes>
//         <Route path="/" element={<DashboardSizeGuides />} />
//         <Route
//           path="/add"
//           element={<NewSizeGuide selectedLanguage={props.selectedLanguage} />}
//         />
//         <Route
//           path="/edit/:id"
//           element={<EditSizeGuide selectedLanguage={props.selectedLanguage} />}
//         />
//       </Routes>
//     </>
//   );
// };

// export default MainSizeGuides;
